import React from 'react';
import SectionIncomingConsignment from '../SectionIncomingConsignment';

const WeavingInwardConsignment = () => (
  <SectionIncomingConsignment
    sectionName="Weaving Section"
    sectionDisplayName="Weaving"
    backRoute="/sections/weaving"
  />
);

export default WeavingInwardConsignment;
